// 直播平台导出
// const obj = platHelper.getQrParam(dataType, this.pid)
// getQrcode(obj).then((res) => {
//   console.log(res)
//   this.$refs.getimg.downloadIamge(res.data.url, this.detail.name)
// })

// 暂时未封装成方法 只封装了参数生成


export function getQrParam(dataType, dataId) {
  let result = {
    path: 'pages/live/index',
    appId: 'wx85f3340de9840fb8',
    dataId: `&${dataType}:${dataId}`,
    isSaas: false,
    dataType: 10000,
  };
  return result;
}
export function getHomeQrParam(shopId) {
  console.log(shopId);
  let result = {
    path: 'pages/shop/index',
    appId: 'wx85f3340de9840fb8',
    dataId: shopId,
    isSaas: false,
    dataType: 10000,
  };
  return result;
}
